import {fetch} from "utils/dataAccess";

// Pushes one method to Sylius right away; answers its sync state, see the API's PushShippingMethodNowController.
export function pushShippingMethodNow(shippingMethod) {
    return fetch(`/shipping_methods/${shippingMethod.id}/sync`, {method: 'POST'}).then(response => response.json());
}
